module.exports = __webpack_public_path__ + "img/13.e95a21a3.png";